<template>
  <b-container fluid style="min-height: calc(100vh - 200px)" class="px-0">
    <b-row>
      <Tables ref="tableGrid"
              class="col-md-5 mb-3 tabela"
              :showPaging="false"
              :showHeader="false"
              :columns="[$lang.NotificationGroups.DataTable.Description,
                        $lang.Common.DataTable.ActionDate,
                        $lang.Common.DataTable.Actions]"
              v-on:Load="onLoad">
        <tr v-for="obj in this.objList" :key="obj.id">
          <TableColumn :IsText="true" v-on:Edit="onEditForm(obj)" :status="obj.status" :value="obj.descricao" />
          <TableColumn :IsDatetime="true" v-on:Edit="onEditForm(obj)" :status="obj.status" :value="obj.dataAcao" />
          <TableColumn :HasChange="false" :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
        </tr>
      </Tables>

      <forms class="col-md-7 mb-0 pl-0"
             id="form"
             :title="$lang.NotificationGroups.Title"
             :showClearButton="true"
             :showSaveButton="true"
             v-on:Clear="onClearForm"
             v-on:Save="onSave">
        <b-form-group :label="$lang.NotificationGroups.LabelDescription">
          <b-input v-model="form.descricao.value" :required="form.descricao.required" :state="form.descricao.state"></b-input>
        </b-form-group>

        <div class="mt-3">
          {{$lang.NotificationGroups.LabelAccounts}}
          <div v-if="form.contas.value && form.contas.value.length" >
            <div v-for="conta in form.contas.value" :key="conta.contaID" class="d-flex align-items-center">
              <b-input :value="getName(conta.contaID)" disabled></b-input>
              <span class="ml-3" style="cursor:pointer;" @click="onRemoveAccount(conta)">
                <i class="fas fa-trash"></i>
              </span>
            </div>
          </div>
          <div class="d-flex align-items-center mt-1">
            <b-select v-model="newAccount" :options="form.contas.options" @change="onSelectAccount"></b-select>
            <span class="ml-3">
              <i class="fas fa-plus"></i>
            </span>
          </div>
        </div>
      </forms>
    </b-row>
  </b-container>
</template>

<script>
import NotificationGroups from './notificationgroups.js'
export default NotificationGroups
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/access/notificationgroups/notificationgroups.vue